'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);

var _SavedSearchesCellMobile = require('./SavedSearchesCellMobile.scss');var styles = _interopRequireWildcard(_SavedSearchesCellMobile);
var _index = require('../index');
var _OMGenericSelect = require('../OMComponents/OMGenericSelect/OMGenericSelect');var _OMGenericSelect2 = _interopRequireDefault(_OMGenericSelect);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var SavedSearchesCellMobile = function SavedSearchesCellMobile(props) {var
  name =
  props.name,email = props.email,filters = props.filters,createdAt = props.createdAt,showResults = props.showResults,translate = props.translate,removeSearch = props.removeSearch,search = props.search,toggleSmartAgentState = props.toggleSmartAgentState;
  return (
    _react2.default.createElement('div', { className: styles.savedSearchesCell },
      _react2.default.createElement('div', { className: styles.titleRow },
        _react2.default.createElement('div', { className: styles.savedAddress }, name),

        _react2.default.createElement('div', { className: styles.savedDate },
          createdAt)),




      _react2.default.createElement('div', { className: styles.savedDatailsWrapper },
        _react2.default.createElement('div', { className: styles.savedDatails },
          _react2.default.createElement('div', { className: styles.savedFilters }, filters),
          _react2.default.createElement('div', { className: styles.savedFilters }, email))),



      _react2.default.createElement('div', { className: styles.actionsRow },
        _react2.default.createElement('div', { className: styles.disableAgent, onClick: function onClick(evt) {return evt.stopPropagation();} },
          _react2.default.createElement('div', null,
            translate('savedSearches', 'smartAgent'), '\xA0',
            _react2.default.createElement(_index.BottomTooltip, {
              closeOnClickOutside: true,
              className: 'smartAgentTooltip',
              msg: props.translate('savedSearches', 'smartAgentDescription'),
              icon: _react2.default.createElement('span', { className: 'icon icon-about' }) })),


          _react2.default.createElement(_index.OMSwitch, {
            id: 'smart-agent-switch',
            label: translate('savedSearches', search.smartAgentIsActive ? 'enable' : 'disable').toString(),
            onChange: toggleSmartAgentState,
            isChecked: !!search.smartAgentIsActive })),



        _react2.default.createElement('div', { className: styles.select, onClick: function onClick(evt) {return evt.stopPropagation();} },
          _react2.default.createElement(_OMGenericSelect2.default, {
            options: [{
              label: translate('savedSearches', 'daily'),
              selected: true,
              value: 'daily' }],

            value: 'daily',
            onChange: function onChange() {} }))),




      _react2.default.createElement('div', { className: styles.savedSearchesButtonsWrapper },
        _react2.default.createElement('button', { onClick: showResults, className: styles.showResults },
          translate('savedSearches', 'showResults')),

        _react2.default.createElement('button', { onClick: removeSearch, className: styles.removeSearch },
          _react2.default.createElement('span', { className: 'icon icon-delete_bucket' })))));




}; // Styles

SavedSearchesCellMobile.propTypes = {
  translate: _propTypes2.default.func.isRequired,
  name: _propTypes2.default.string,
  email: _propTypes2.default.string,
  search: _propTypes2.default.object,
  filters: _propTypes2.default.string,
  createdAt: _propTypes2.default.string,
  showResults: _propTypes2.default.func,
  toggleSmartAgentState: _propTypes2.default.func,
  removeSearch: _propTypes2.default.func };exports.default =


SavedSearchesCellMobile;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SavedSearchesCell/SavedSearchesCellMobile.js
// module id = 2916
// module chunks = 0